<nav class="navbar navbar-expand-lg navbar-light bg-white">
  <div class="container-fluid">
    <!-- Brand/Logo -->
    <logo-component></logo-component>
    <ng-container *ngIf="(houses$ | async) as houses">
      <!-- Einzelnes Haus: einfaches Label -->
      <a class="navbar-brand" href="#" *ngIf="houses.length <= 1">{{ householdLabel }}</a>

      <!-- Mehrere Häuser: Dropdown -->
      <span *ngIf="houses.length > 1" class="navbar-brand-select-wrapper">
        <span class="navbar-brand-select-sizer" aria-hidden="true">{{ longestHouseLabel }}</span>
        <mat-select [value]="selectedHouseId$ | async"
                    (selectionChange)="onHouseChange($event.value)"
                    panelWidth="auto"
                    class="navbar-brand-select">
          <mat-option *ngFor="let houseId of houses" [value]="houseId">
            {{ (houseLabels$ | async)?.[houseId] || houseId }}
          </mat-option>
        </mat-select>
      </span>
    </ng-container>

    <!-- Toggler for responsive design -->
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Navbar Links -->
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
      </ul>

      <ul >
        <div class="login-logout">
          <button matButton="outlined" (click)="loginRedirect()" *ngIf="!loginDisplay">Login</button>

          <user-avatar class="user-avatar" *ngIf="loginDisplay"></user-avatar>
        </div>

      </ul>
    </div>
  </div>
</nav>
